import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import * as fromSaBia from 'src/app/root-store/sa-bia/sa-bia.selectors';
import { distinctUntilChanged, map, skipWhile } from 'rxjs/operators';
import { BiaUtils } from 'src/@utility/bia.utils';

@Injectable({
  providedIn: 'root',
})
export class BiaImpactService {
  constructor(private store: Store) {}

  load(templateId) {
    return this.store
      .select(fromSaBia.getITGroupsLoaded, { id: templateId })
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        skipWhile((ivs) => !ivs.impactTemplates),
        map((ivs) => {
          const { impactTemplates, impactTypes, maos, rtos } = ivs;
          let criticalMissionMet = true;
          const sortedMaos = [...maos].sort(BiaUtils.sortTime);
          const sortedRtos = [...rtos].sort(BiaUtils.sortTime);
          const rtoMissionCriticalIdx = sortedRtos.findIndex(
            (rto) => rto.isMissionCritical
          );

          return {
            // Impact Template
            impactTemplate: impactTemplates,

            // MAOS
            maos: sortedMaos.map((mao) => {
              if (mao.rto && mao.rto.isMissionCritical) {
                criticalMissionMet = false;
              }

              return {
                ...mao,
                rto: mao.rto
                  ? {
                      ...mao.rto,
                      isMissionCritical: criticalMissionMet
                        ? criticalMissionMet
                        : mao.rto.isMissionCritical,
                    }
                  : mao.rto,
                display: BiaUtils.getTimeString(mao),
              };
            }),

            // Impact Type and its values
            impactTypes: impactTypes.map((its) => {
              const impactValues = [...its.saImpactValues].sort(
                (iv1, iv2) => iv1.priority - iv2.priority
              );

              const thresholdIV = impactValues.find(
                (iv) => iv.isThresholdLevel
              );
              const thresholdPriority = thresholdIV ? thresholdIV.priority : 99;

              const maoThresholdIV = impactValues.find(
                (iv) => iv.isMaoThreshold
              );
              const maoThresholdPriority = maoThresholdIV
                ? maoThresholdIV.priority
                : 99;

              const rtoThresholdIV = impactValues.find(
                (iv) => iv.isRtoThreshold
              );
              const rtoThresholdPriority = rtoThresholdIV
                ? rtoThresholdIV.priority
                : 99;

              return {
                ...its,
                saImpactValues: impactValues.map((iv) => ({
                  ...iv,
                  isThresholdLevel: iv.priority <= thresholdPriority,
                  isMaoThreshold:
                    impactTemplates.impactMethodologyPage.pageId == 'P_IM_TONE'
                      ? !!iv.isMaoThreshold
                      : iv.priority <= maoThresholdPriority,
                  isRtoThreshold:
                    impactTemplates.impactMethodologyPage.pageId == 'P_IM_TONE'
                      ? !!iv.isRtoThreshold
                      : iv.priority <= rtoThresholdPriority,
                })),
              };
            }),

            // RTOS
            rtos: rtos.map((rto, idx) => ({
              ...rto,
              display: BiaUtils.getTimeString(rto),
              isMissionCritical:
                impactTemplates.impactMethodologyPage.pageId == 'P_IM_TONE'
                  ? rto.isMissionCritical
                  : idx <= rtoMissionCriticalIdx,
            })),
          };
        })
      );
  }
}
